/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Вид для блока с количеством и кнопкой "в корзине" для товара в каталоге
   */
  app.CategoryItemQtyView = app.ItemQtyView.extend({
    el: '.btn-block',
    additionalOptions: ['item', 'collection'],

    /** @inheritDoc */
    run: function () {
      var templateSelector = '.btn-template';
      if (this.collection.viewtype === 'cards' && !app.isMobile) {
        templateSelector = '.btn-cards-template';
      }
      if (this.collection.viewtype === 'xxl') {
        templateSelector = '.btn-xxl-template';
      }
      if (this.item.get('type') === app.PRODUCT_SERVICE_TYPE && app.isMobile) {
        templateSelector = '.btn-service-template';
      }
      this.btn_template = app.helpers.TemplateHelper.getTemplate(templateSelector);
      this.wtfId = this.item.get('id');
      this.price = this.item.get('price');
      this.minimum = this.item.get('minQty');
      this.maximum = this._initMaximum();
      // при очистке корзины
      this.listenTo(this.cart, 'clear', this.remove.bind(this));
      this.value = this.model.get('qty');
      this.addCartItemToCart();
    },

    /**
     * Определяет доступен ли в текущем городе пользователя транзитный товар
     * @param {app.Model} model модель
     * @param {app.Model} settlement город
     * @returns {boolean}
     */
    isTransitUnavailable: function(model, settlement) {
      return model
        && model instanceof app.Model
        && settlement
        && settlement instanceof app.Model
        && model.get('transit_in_settlement')
        && model.get('transit_in_settlement').indexOf(settlement.get('settlement_id')) === -1;
    },

    /**
     * Рендерит блок цены
     */
    render: function (options) {
      var isTransitUnavailable = this.isTransitUnavailable(this.item, this.settlement),
        qty = this.model.get('qty'),
        hasMarkup = this.item.get('real_min_qty') > qty;
      if (qty && this.item.get('has_custom_qty_units')) {
        qty = this.convertQtyBasedOnNestedUnit(qty, this.item.get('in_set'), 'to');
      }
      if (!(this.item.get('isEnough') === false && this.item.get('balance') === 0)) {
        this.$el.html(this.btn_template({
          visibleQty: this.getVisibleValue(qty),
          qty: qty,
          model: this.item.toJSON(),
          qtyRule: hasMarkup ? '' : this.getQtyRule(),
          cartItem: this.model.toJSON(),
          isTransitUnavailable: isTransitUnavailable,
        }));
        this.initDom();
        if (options && !isTransitUnavailable){
          this.updateControls.apply(this, options.controls);
        }
        this.renderRetailFeeMarkup();
      } else if (this.item.get('is_gift') || this.collection.viewtype !== 'list' || app.isMobile) {
        this.$el.empty();
      } else {
        this.$el.html('<div class="catalog__item-not-in-stock"><span>Нет в наличии</span></div>');
      }
    },

    /**
     * Необходимо, чтобы не сдвигался тултип "Добавлено в корзину"
     * в категориях
     */
    calculateHeaderPosition: function () {
      return 0;
    },
  });
})();

}.call(window));